import { FC, useState } from 'react';
import { Icon, Button } from 'common-components';
import styles from './optionList.module.scss';
import { ClickAwayListener } from '../../uiLibraryImports';
import { useTranslationContext } from '../../contexts/translationContext';

const OptionList: FC<OptionListProps> = (props: OptionListProps) => {
    const { options, onClose, style = {} } = props;
    const [selected, setSelected] = useState<string>('');
    const { translate } = useTranslationContext();

    const onItemClick = (item: Option) => {
        if (item.showAnswerOptions) {
            setSelected(item.key);
        } else {
            item.onClick();
            onClose();
        }
    };

    const onApprove = item => {
        item?.onClick();
        onClose();
    };

    return (
        <ClickAwayListener onClickAway={() => onClose()}>
            <div className={styles['option-list']} style={{ ...style }}>
                <div className={styles['option-list-items']}>
                    {options.map(item => (
                        <div
                            className={selected === item.key ? styles['selected-item'] : styles['option-list-item']}
                            key={item.key}
                            onClick={() => onItemClick(item)}
                        >
                            <div className={styles['top-wrapper']}>
                                <Icon name={item.icon} className={styles.icon} />
                                <div className={styles.text}>{item.text}</div>
                            </div>
                            {item.key === selected && (
                                <div className={styles['actions-wrapper']}>
                                    <hr />
                                    <div className={styles['buttons-wrapper']}>
                                        <Button
                                            type="learningPanelAdminActionButton"
                                            onClick={onClose}
                                            text={translate('Cancel')}
                                            lowerCase
                                        />
                                        <div style={{ marginLeft: '0.5re' }}>
                                            <Button
                                                type="learningPanelAdminActionButton"
                                                onClick={() => onApprove(item)}
                                                text={translate('Approve')}
                                                lowerCase
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </ClickAwayListener>
    );
};

export default OptionList;

export interface OptionListProps {
    options: Option[];
    onClose: Function;
    style?: object;
}

export interface Option {
    key: string;
    text: string;
    icon: string;
    onClick: Function;
    showAnswerOptions?: boolean;
}
